<template>
    <div class="container-pieChart_v2">
        <v-chart :options="option" ref="ff"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/pie'



import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'


export default {
  name: 'pieChart_v2',
  props: {  
    title:{
      type: String,
      default: ""
    },
    type:{
      type:String,
      default:"membership_structure"
    }
  },
  data () {  
    return {     
       option:{},
       data:[],
    }
  },
  methods: {
 
  },
  mounted () {
    var that=this;
    if(that.type=="membership_structure"){
      that.data=[
                    {value: 45, name: '活跃会员',itemStyle:{color:'#4346D3'}},
                    {value: 15, name: '沉睡会员',itemStyle:{color:'#2D99FF'}},
                    {value: 25, name: '沉默会员',itemStyle:{color:'#6648FF'}},
                    {value: 15, name: '流失会员',itemStyle:{color:'#43D3C9'}}
                ]
    }else{
       that.data=[
                    {value: 25, name: '重复两次购买',itemStyle:{color:'#4346D3'}},
                    {value: 15, name: '重复3次购买',itemStyle:{color:'#2D99FF'}},
                    {value: 15, name: '重复3+次购买',itemStyle:{color:'#6648FF'}},
                    {value: 45, name: '单次购买',itemStyle:{color:'#43D3C9'}}
                ]
    }
    this.ff=this.$refs.ff,
    this.option = {
       title: {
              // zlevel: 0,
              text: this.title,
              textStyle:{
                color:'#4FAEFF',
                fontSize:18,
                fontWeight :"normal"
              },
             
               x: 'center',//文字位置
               
              //  y:'30px'//文字位置
          },
             tooltip :{
		
          trigger: "axis",
          axisPointer: {
            type: "none",
        
          }
				},
        
         
        series: [
            {
            
                type: 'pie',
                radius: ['20%', '35%'],   
            
               minAngle: 5,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                avoidLabelOverlap: true,   //是否启用防止标签重叠策略
                labelLine:{  
                    normal:{  
                        
                          lineStyle: {
                            color: "#fff"  // 改变标示线的颜色
                          }
                    }
                },
                label: {
                      align:"center",
                     
                     width:50,
                      rich:{},
                      formatter: (text) => {                    
                        let percent=text.percent+"%";     
                        return text.name+"\n"+percent;
                      },
                      
                    
                        color: '#fff',  // 改变标示文字的颜色
                        fontSize:14
                          
                    
                },
                emphasis: {
                   
                   label:{
                     color:"#EACD2C"
                   }
                },
                
                data: that.data
                
            }
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-pieChart_v2{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>